module.exports = __webpack_public_path__ + "img/company4.fe093ae8.jpg";